import './facets-selector.scss';

let count = 0;
let facetCountSelector = null;

const widgetSelector = '.facets-widget-checkbox, fieldset.fieldgroup.form-item';
const checkboxSelector = '.facets-checkbox, .form-checkbox';

function filterSelectionDisplay() {
  const activeFilters = document.querySelectorAll('.facet-summary-item--facet, .views-filters-summary .value');
  const filterSection = document.querySelector('#activeFilterSection');
  const sectionsToHide = document.querySelectorAll('.filter-hide');

  if (activeFilters.length > 1) {
    // display active filter section.
    filterSection.classList.add('active');

    // hide super vedette news and jumbotron when filter active.
    sectionsToHide.forEach(section => {
      section.classList.add('hide');
    })
  }
  else {
    sectionsToHide.forEach(section => {
      section.classList.remove('hide');
    })

    if (filterSection) {
      filterSection.classList.remove('active');
    }
  }
}

function initFacet() {
  document.addEventListener('FacetInit', () => {
    // filters selection display.
    filterSelectionDisplay();

    //filter menu
    const navFilterSection = document.querySelector('#bannerMenu');
    const filterMenuItems = document.querySelectorAll('.bannerMenuItems');

    // adding filter items to banner nav section.
    if (navFilterSection) {
      filterMenuItems.forEach(item => {
        navFilterSection.appendChild(item);
      });
    }
  });

  const FacetInit = new Event('FacetInit');
  document.dispatchEvent(FacetInit);
}

// Function to open facets selector panel
function openFacetsPanel() {
  document.querySelectorAll('.facets-selector-content').forEach(panel => {
    panel.classList.add('open');
    panel.style.display = 'flex';
  });
  document.getElementById('facets-selector-overlay').style.display = 'block';
  document.body.classList.add('prevent-scroll');
}

// Function to close facets selector panel
function closeFacetsPanel() {
  document.querySelectorAll('.facets-selector-content').forEach(panel => {
    panel.classList.remove('open');
    panel.style.display = 'none';
  });
  document.getElementById('facets-selector-overlay').style.display = 'none';
  document.body.classList.remove('prevent-scroll');
}

// Function to check if facets panel is open
function isFacetsPanelOpen() {
  return document.querySelector('.facets-selector-content.open') !== null;
}

function toggleFacetTogglePanel() {
  if (document.querySelectorAll(".facets-selector-toggle")) {
    document.querySelectorAll(".facets-selector-toggle").forEach(toggle => {
      toggle.onclick = (event) => {
        event.preventDefault();

        if (isFacetsPanelOpen()) {
          closeFacetsPanel();
        } else {
          openFacetsPanel();
        }
      };
    });

    // Close facets panel when clicking on overlay (outside panel)q
    const facetsOverlay = document.getElementById('facets-selector-overlay');
    if (facetsOverlay) {
      facetsOverlay.addEventListener('click', (event) => {
        event.preventDefault();
        closeFacetsPanel();
      });
    }
  }
}

function toggleFacetToggleSection() {
  document.querySelectorAll(widgetSelector).forEach(toggle => {
    if (!toggle.classList.contains('active')) {
      toggle.classList.add('active');
      if (toggle.querySelector('.item-list__checkbox')) {
        toggle.querySelector('.item-list__checkbox').style.display = 'block';
      }

    } else {
      if (toggle.querySelector('.item-list__checkbox')) {
        toggle.classList.remove('active');
        toggle.querySelector('.item-list__checkbox').style.display = 'none';
      }
    }
  });
}

function toggleFacetCheckboxLogic() {
  if (document.querySelectorAll(widgetSelector)) {
    document.querySelectorAll(".facets-widget-checkbox .facets-checkbox").forEach(checkbox => {
      let checkboxEvent = checkbox._getEventListeners();
      if (!window.eventListener._hasEvents(checkboxEvent)) {
        checkbox.onclick = () => {
          countFacets();
        }
      }
    });
  }
}

function resetFacetsCheckbox() {
  let resetFacets = document.querySelector('.js-facet-reset');
  if (resetFacets) {
    //Only add events if no event listener on object
    let folderEvent = resetFacets._getEventListeners();
    const clearButton = '.facet-summary-item--clear, .facets-selector-content [name="reset"]';
    if (!window.eventListener._hasEvents(folderEvent)) {
      resetFacets.onclick = () => {
        if (document.querySelector(clearButton)) {
          document.querySelector(clearButton).click(); // Trigger click on element with class
        }
        document.querySelectorAll(widgetSelector).forEach(toggle => {
          toggle.querySelectorAll(checkboxSelector).forEach(checkbox => {
            count = 0;
            if (checkbox.checked) {
              checkbox.checked = false;
            }
          });
        });
        toggleFacetCheckboxLogic();
        countFacets();
      }
    }
  }

}

function countFacets() {
  count = 0;

  document.querySelectorAll(widgetSelector).forEach(toggle => {
    toggle.querySelectorAll(checkboxSelector).forEach(checkbox => {
      if (checkbox.checked) {
        count++;
      }
      hideResetButton();
    });
  });

  facetCountSelector.innerText = count;
}

function resetInputText() {
  document.querySelectorAll('.form-item-search .js-input-clear').forEach(clear => {
    let clearEvent = clear._getEventListeners();
    if (!window.eventListener._hasEvents(clearEvent)) {
      const searchInput = clear.closest('.form-item-search').querySelector('input.form-text');
      clear.addEventListener('click', (_e) => {
        if (searchInput.value != '') {
          _e.preventDefault();
          searchInput.value = '';
        }
        hideResetButton();
      });
    }
  });
}

function hideResetButton() {
  const selector = document.querySelector('.js-facet-reset');
  if (selector) {
    if (count == 0) {
      selector.style.display = 'none';
    } else {
      selector.style.display = 'block';
    }
  }
}

function displayFacetsFix() {
  document.addEventListener('search_reloaded', () => {
    const FacetInit = new Event('FacetInit');
    document.dispatchEvent(FacetInit);
    document.querySelectorAll('.js-facets-checkbox-links').forEach(checkbox => {
      checkbox.style.display = 'block';
      hideResetButton();
    });
  });

  document.addEventListener('searchResultsAjaxLoaded', () => {
    filterSelectionDisplay();
  });
}

function addArticleReloadedLogic() {
  document.addEventListener('sollio_articles_reloaded', () => {
    asyncFacetInit();
    // On next tick close panel if open:
    setTimeout(() => {
      if (isFacetsPanelOpen()) {
        closeFacetsPanel();
      }
    }, 0);

  });
}

function asyncFacetInit() {
  facetCountSelector = document.querySelector('.js-facets-count');
  if (facetCountSelector) {
    toggleFacetCheckboxLogic();
    countFacets();
  }
}

function facetInit() {
  facetCountSelector = document.querySelector('.js-facets-count');

  if (facetCountSelector) {
    // facets selector toggle
    initFacet();
    toggleFacetTogglePanel();
    toggleFacetToggleSection();
    toggleFacetCheckboxLogic();
    resetFacetsCheckbox();
    countFacets();
    resetInputText();
    displayFacetsFix();
    hideResetButton();
    addArticleReloadedLogic();
  }

  initSearchRefresh();
}

function initSearchRefresh() {
  const inputElement = document.querySelector('.node--type-recherche #edit-search');
  const submitButton = document.querySelectorAll('.node--type-recherche .search-page__input-search__submit');

  if (submitButton && inputElement) {
    submitButton.forEach(element => {
      let submitEvent = element._getEventListeners();
      if (!window.eventListener._hasEvents(submitEvent)) {
        element.addEventListener('click', function (event) {
          event.preventDefault(); // prevent the default form submission
          const inputValue = inputElement.value;
          rebuildSearchParam(inputValue);
        });
      }

    });
  }

  if (inputElement) {
    inputElement.addEventListener('keydown', function (event) {
      let keyboardEvent = inputElement._getEventListeners();
      if (!window.eventListener._hasEvents(keyboardEvent)) {
        if (event.key == 13) { // check if Enter key was pressed
          event.preventDefault(); // prevent the default form submission
          const inputValue = inputElement.value;
          rebuildSearchParam(inputValue);
        }
      }
    });
  }

}

function rebuildSearchParam(inputValue) {
  const urlParams = new URLSearchParams();
  urlParams.set("search", inputValue);
  const newUrl = window.location.origin + window.location.pathname + "?" + urlParams.toString();
  setTimeout(() => {
    window.location.href = newUrl;
  }, 100);
}

(function ($) {

  Drupal.behaviors.dispatchLoadedAjaxContent = {
    attach: function (_context, _settings) {
      if (_context !== document) {
        return;
      }
      $(document).ajaxSuccess(function (_event, _data) {

        if (drupalSettings && drupalSettings.views && drupalSettings.views.ajaxViews) {
          const ajaxViews = drupalSettings.views.ajaxViews;

          Object.keys(ajaxViews || {}).forEach(function (i) {
            if (ajaxViews[i]['view_name'] == 'sollio_search' || ajaxViews[i]['view_name'] == 'sollio_articles' || ajaxViews[i]['view_name'] == 'sollio_news') {
              setTimeout(function () {
                const eventSearch = new Event('search_reloaded');
                const eventRelatedLoaded = new Event('relatedLoaded');
                const eventArticle = new Event('sollio_articles_reloaded');
                const elementsToRemove = document.querySelectorAll('.ajax-progress-fullscreen');
                elementsToRemove.forEach(element => {
                  element.remove();
                });
                document.dispatchEvent(eventSearch);
                document.dispatchEvent(eventArticle);
                document.dispatchEvent(eventRelatedLoaded);
                const searchResultsAjaxLoaded = new Event('searchResultsAjaxLoaded');
                document.dispatchEvent(searchResultsAjaxLoaded);
              }, 5);
            }
          });
        }
      });
    }
  }

  Drupal.behaviors.facetsSubmit = {
    attach: function (context, settings) {
      once('facets_submit','.facets-selector-content',context).forEach(element => {
        const wrapper = element;

        wrapper.querySelectorAll('.facets-apply-button').forEach(button => {
          button.addEventListener('click', function (event) {
            event.preventDefault();
            wrapper.querySelector('.views-exposed-form .form-submit').click();
          });
        })
      })
    }
  }
})(jQuery);

// The same exposed filter form is embedded 3 times on a search page (search
// banner, header search dropdown, and this filter panel), all sharing the
// same DOM id. views_filters_summary's reset/remove-filter links resolve the
// form to act on via document.querySelector on that id, which always returns
// the banner's copy instead of the one the user is actually looking at, so
// "Reset all" appeared to work (it does clear the URL/results) while the
// panel's own checkboxes stayed checked. Prefer the copy inside the filter
// panel, when one is present, over whichever form happens to be first in the
// DOM.
function patchViewsFiltersSummaryReset() {
  if (!window.Drupal || !Drupal.ViewsFiltersSummaryHandler) {
    return;
  }
  const proto = Drupal.ViewsFiltersSummaryHandler.prototype;
  if (proto._sollioPanelFormPatch) {
    return;
  }
  proto._sollioPanelFormPatch = true;
  const originalGetExposedForm = proto.getExposedForm;
  proto.getExposedForm = function () {
    if (!this.exposedForm) {
      const summaryElt = this.context.querySelector('[data-exposed-form-id]');
      const exposedFormId = summaryElt && summaryElt.getAttribute('data-exposed-form-id');
      const panelForm = exposedFormId
        ? document.querySelector(`.facets-selector-content form[id^="${exposedFormId}"]`)
        : null;
      if (panelForm) {
        this.exposedForm = panelForm;
        return this.exposedForm;
      }
    }
    return originalGetExposedForm.call(this);
  };
}

window.addEventListener('load', () => {
  facetInit();
  patchViewsFiltersSummaryReset();
});
